import { ArrowsRightLeftIcon } from "@heroicons/react/16/solid";
import { useNavigate } from "react-router";
import { OverflowFrame, PageHeading } from ".";
import { Link } from "./tailwind/link";
import { Text } from "./tailwind/text";

export const DuplicateCampaignOrAutomation = () => {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);

  const campaignId = urlParams.get("campaign") ?? "";
  const campaignName = urlParams.get("campaignName") ?? "";
  const automationId = urlParams.get("automation") ?? "";
  const automationName = urlParams.get("automationName") ?? "";
  const automationType = urlParams.get("automationType") ?? "";

  const handleDuplicateNew = async () => {
    var urlParams = [];
    if (campaignId !== "") {
      urlParams.push(`campaign=${campaignId}`);
      urlParams.push(`campaignName=${campaignName}`);
      urlParams.push(`next_page=campaigns`);
    }
    if (automationId !== "") {
      urlParams.push(`automation=${automationId}`);
      urlParams.push(`automationName=${automationName}`);
      urlParams.push(`next_page=${automationType}`);
    }
    navigate(`/templates?${urlParams.reduce((cur, acc) => acc + "&" + cur)}`);
  };

  const handleDuplicateSelect = async () => {
    var urlParams = [];
    if (campaignId !== "") {
      urlParams.push(`campaign=${campaignId}`);
      urlParams.push(`campaignName=${campaignName}`);
      navigate(
        `/campaigns/new/template/?${urlParams.reduce(
          (cur, acc) => acc + "&" + cur,
        )}`,
      );
    }
    if (automationId !== "") {
      urlParams.push(`automation=${automationId}`);
      urlParams.push(`automationName=${automationName}`);
      navigate(
        `/automations/new/${automationType}/?${urlParams.reduce(
          (cur, acc) => acc + "&" + cur,
        )}`,
      );
    }
  };

  const classLink =
    "hover:cursor-pointer w-80 h-80 p-3 border rounded-customBorderRadius shadow-shadowbuttonmin hover:shadow-shadowbuttonpink flex flex-col justify-center items-center";
  const classTitle = "text-xl text-center font-bold";
  const classText = "text-base text-center";
  return (
    <>
      <PageHeading
        title={`Duplicate ${campaignId === "" ? automationName : campaignName}`}
      />
      <OverflowFrame>
        <div className="flex flex-col max-w-[1024px] justify-evenly items-center m-auto h-full md:flex-row p-5 md:p-0">
          <Link className={classLink} onClick={() => handleDuplicateSelect()}>
            <div>
              <Text className={classTitle}>Existing WhatsApp template</Text>
              <Text className={classText}>
                I already have my first message validated
              </Text>
            </div>
          </Link>
          <ArrowsRightLeftIcon className="h-20 text-zinc-500 rotate-90 md:rotate-0" />
          <Link className={classLink} onClick={() => handleDuplicateNew()}>
            <Text className={classTitle}>New WhatsApp template</Text>
            <Text className={classText}>
              I want to create a new first message for the flow
            </Text>
          </Link>
        </div>
        <div className="mx-auto flex w-full max-w-7xl items-start py-5 gap-x-8"></div>
      </OverflowFrame>
    </>
  );
};

export default DuplicateCampaignOrAutomation;
